import React from 'react';
import { FaIndustry, FaFlask, FaTruck, FaNetworkWired, FaLeaf, FaLightbulb } from 'react-icons/fa';
import './technology-innovation.css';

const innovations = [
  {
    icon: <FaIndustry size={28} />,
    title: 'Lagoon-Type Anaerobic Digesters',
    text: 'Low-maintenance, large-scale digesters that decompose food and agri-waste naturally to produce methane-rich gas—reducing solids, odors, and costs.',
  },
  {
    icon: <FaFlask size={28} />,
    title: 'Advanced Gas Purification',
    text: 'State-of-the-art Gas Purification and H₂S removal units ensure high methane purity, non-corrosive gas, and environmental compliance.',
  },
  {
    icon: <FaTruck size={28} />,
    title: 'Low-Pressure Mobile Vessels',
    text: 'Gas delivered at 0.5–1 bar in certified vessels, eliminating high-pressure systems. Benefits: safe transport, flexible supply, and reduced CAPEX/OPEX.',
  },
  {
    icon: <FaNetworkWired size={28} />,
    title: 'Hub-and-Spoke Delivery Model',
    text: 'Our mobile “energy hubs” ensure timely, reliable CBG delivery even in remote areas—solving storage bottlenecks and ensuring continuity.',
  },
  {
    icon: <FaLeaf size={28} />,
    title: 'Sustainability & Carbon Benefits',
    text: 'Our closed-loop system recovers energy, reduces emissions, and contributes directly to India’s net-zero goals.',
  },
  {
    icon: <FaLightbulb size={28} />,
    title: 'Continuous Innovation',
    text: 'We invest constantly in R&D, optimization, and safety to lead India toward a greener, energy-independent future.',
  },
];

const TechnologyInnovation = () => {
  return (
    <div className="technology-innovation-page">
      <div className="container pt-5 pb-5">
        <div className="text-center mb-5">
          <h1 className="fw-bold">Technology & Innovation</h1>
          <p className="lead text-muted">Innovation powers everything we do. We merge engineering excellence with modern science to deliver clean, efficient, and reliable CBG systems.</p>
        </div>

        <div className="row g-4">
          {innovations.map((item, index) => (
            <div className="col-lg-4 col-md-6" key={index}>
              <div className="card tech-card p-4 text-center">
                <div className="icon-wrapper">
                  {item.icon}
                </div>
                <h5 className="fw-bold">{item.title}</h5>
                <p className="text-muted small">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default TechnologyInnovation;
